import { pushToDataLayer } from './pushToDatalayer';
import { getParameters } from './formatter';
import { EVENTS } from './core/constants';
import { isDebugMode } from './core/utils';
import { savePromotion, clearPromotion } from './core/promotion';
import type { EventName, InitialConfig, PayloadFor, TrackMeta } from './types';

let config: InitialConfig = { brand: '', currency: 'BRL' }
export function initTracker(c: InitialConfig) {
  config = c
}

async function trackWebEvent<E extends EventName>(event: E, context: PayloadFor<E>) {
  try {
    const parameters = await getParameters(context, event, config);

    if (event === 'SELECT_PROMOTION' && parameters) {
      const meta = (context.meta ?? {}) as TrackMeta;
      savePromotion({
        promotion_name: meta.promotion_name ?? null,
        creative_name: meta.creative_name ?? null,
        creative_slot: meta.creative_slot ?? null,
        promotion_url: meta.promotion_url ?? null, // só pro cookie; não vai pro datalayer
      });
    }

    if (isDebugMode()) {
      console.log(
        `%c [DT v${__LIB_VERSION__}] %c ${event} `,
        'background: #6366f1; color: #fff; font-weight: bold; padding: 2px 6px; border-radius: 4px 0 0 4px;',
        'background: #1e1e2e; color: #a5b4fc; font-weight: bold; padding: 2px 6px; border-radius: 0 4px 4px 0;',
        { context, parameters }
      )
    }

    const result = await pushToDataLayer(event, Object.assign({}, parameters, { window: context.window }));

    if (event === 'PURCHASE' || event === 'CUSTOM_PURCHASE') {
      clearPromotion();
    }

    return result;
  } catch (err) {
    return console.error(`[DT] Error tracking event ${event}:`, err);
  }
}

export { trackWebEvent, EVENTS };

export default {
  trackWebEvent,
  EVENTS,
}
